<template>
  <van-index-bar>
    <div
      class="vant-content"
      v-for="item in brandList"
      :key="item.letter"
      :id="item.letter"
    >
      <van-index-anchor :index="item.letter" class="van-index" />
      <van-cell
        class="van-cell"
        v-for="subItem in item.list"
        :key="subItem.brandName"
        @click="chooseCarBrandFn(subItem)"
        >{{ subItem.brandName }}</van-cell
      >
    </div>
  </van-index-bar>
</template>

<script>
import { getBrandList } from "@/services/C2C";
import Vue from "vue";
import { IndexBar, IndexAnchor, Cell } from "vant";

Vue.use(IndexBar);
Vue.use(IndexAnchor);
Vue.use(Cell);

export default {
  data() {
    return {
      brandList: []
    };
  },
  mounted() {
    this.fnGetBrandList();
  },
  methods: {
    fnGetBrandList() {
      getBrandList({}).then(res => {
        if (res.code === 200) {
          const brandList = res.result.brandList;
          // 创建一个空的对象数组
          const list = {
            A: [],
            B: [],
            C: [],
            D: [],
            E: [],
            F: [],
            G: [],
            H: [],
            I: [],
            J: [],
            K: [],
            L: [],
            M: [],
            N: [],
            O: [],
            P: [],
            Q: [],
            R: [],
            S: [],
            T: [],
            U: [],
            V: [],
            W: [],
            X: [],
            Y: [],
            Z: []
          };
          const listKeys = Object.keys(list);
          // 把品牌按字母分类
          brandList.map(item => {
            const letter = item.letter;
            list[letter].push(item);
          });
          // 生成一个符合渲染条件的数组
          const brandListnew = listKeys.map(key => {
            return { letter: key, list: list[key] };
          });
          // 删除无效数组
          for (let index = listKeys.length - 1; index >= 0; index--) {
            const ele = brandListnew[index];
            if (!ele.list.length) {
              brandListnew.splice(index, 1);
            }
          }
          this.brandList = brandListnew;
        }
        if (res.code === 1011) {
          // 用户已经预约过了
          this.$toast("已为您提前锁定活动名额~");
        }
      });
    },
    chooseCarBrandFn(ele) {
      const { brandName, brandId } = ele;
      this.$router.push({
        path: "/C2C/car-type",
        query: {
          ...this.$route.query,
          brandName: brandName,
          brandId: brandId
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
/deep/.van-index-bar__index {
  line-height: normal;
  padding-right: 10px;
  font-size: 26px;
}
/deep/.van-index {
  line-height: 60px;
  font-size: 24px;
}
.vant-content {
  .van-index {
    width: 100%;
    height: 60px;
    line-height: 60px;
    background: #f5f5f5;
    font-family: PingFangSC-Semibold;
    font-size: 24px;
    color: #778690;
    letter-spacing: 0;
    text-align: left;
    box-sizing: border-box;
  }
  .van-cell {
    width: 100%;
    height: 80px;
    line-height: 80px;
    display: block;
    text-align: left;
    padding-left: 40px;
    font-family: PingFangSC-Semibold;
    font-size: 24px;
    color: #141E25;
    letter-spacing: 0;
  }
}
</style>
